// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_DesvincularPlanoContasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for desvincular_plano_contas endpoint
 *
 * POST /despesas/desvincular_plano_contas/{id}
 *
 * Unlinks an expense from its associated chart of accounts (plano de contas).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Despesas_DesvincularPlanoContasResponseDados {
despesa_id: number
desvinculado: boolean
}

export type Despesas_DesvincularPlanoContasResponse = ApiResponse<Despesas_DesvincularPlanoContasResponseDados>;

registerResponseContract('Despesas_DesvincularPlanoContasResponse', {
  despesa_id:   { type: 'number',  required: true },
  desvinculado: { type: 'boolean', required: true },
})
